// react
import { MouseEvent, useState } from 'react';

// types
import { Loan, Project, ProjectPayload } from '../../../@types';

// i18n
import { useTranslation } from 'react-i18next';

// dialogs
import { DialogActions } from '../DialogActions/DialogActions';

// fields
import { FormOnboardLoan } from '../../forms/FormOnboardLoan/FormOnboardLoan';

// props
export interface DialogOnboardLoanProps {
	isOpen: boolean;
	onClose: (e: MouseEvent<HTMLButtonElement | HTMLAnchorElement | HTMLFormElement>) => void;
	onSuccess: (e: MouseEvent<HTMLFormElement>, project: Project) => void;
	project: ProjectPayload;
	loan: Loan;
}

export const DialogOnboardLoan = ({
	isOpen,
	loan,
	onClose,
	onSuccess,
	project,
}: DialogOnboardLoanProps) => {
	// hooks
	const { t } = useTranslation();

	// state
	const [isLoading, setIsLoading] = useState(false);

	return (
		<DialogActions
			actions={[
				{
					children: t('cancel'),
					onClick: onClose,
					variant: 'text',
				},
				{
					children: t('onboard'),
					form: 'form-onboard-loan',
					loading: isLoading,
					type: 'submit',
					variant: 'contained',
				},
			]}
			alignItems="center"
			isOpen={isOpen}
			IconCircleProps={{
				type: 'loan',
			}}
			maxWidth={700}
			onClose={onClose}
			subtitle={{
				children: loan?.name,
			}}
			title={{
				children: t('onboardId', { id: `${loan?.code}` }),
			}}>
			<FormOnboardLoan
				loan={loan}
				onClose={onClose}
				onSuccess={onSuccess}
				project={project}
				setIsLoading={setIsLoading}
			/>
		</DialogActions>
	);
};
